import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';
import { PayloadAction } from '@reduxjs/toolkit';

import CustomerGateway from '~apis/customer';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';
import { TCreateNewCustomerReduxParams } from '~types/feat/customer';

import { ErrorMessages, SuccessMessages } from '~utils/constants';

export default function* watchCreateNewCustomer(api: CustomerGateway): SagaWatcherReturnType {
    yield takeEvery('customer/customerCreateNewCustomerAttempt', handleCreateNewCustomer, api);
}

function* handleCreateNewCustomer(api: CustomerGateway, data: PayloadAction<TCreateNewCustomerReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    const {
        ...restOfPayload
    } = data.payload;

    const response = yield* call([api, api.createNewCustomer], {
        authToken,
        ...restOfPayload,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.customerCreateNewCustomerFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.customerCreateNewCustomerSuccess());
        yield put(combinedActions.customerSetCreateNewCustomerModalIsOpen(false));
        yield put(combinedActions.customerSetCustomerListingIndex({ index: 0 }));
        yield put(combinedActions.customerGetCustomerListingAttempt());

        toast.success(SuccessMessages.CustomerCreateNewCustomerSuccess);
    }
}
